export default __webpack_public_path__ + "static/media/Bio-informatics_andclinical.0050a63b.png";